import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import UpgradeTypeModel from 'js/models/upgrade.type.model';

    export default Backbone.Collection.extend({
        model: UpgradeTypeModel,
        url: "/CampaignCloud/CreditsController/UpgradeTypes",
        parse: function (response) {
            if (response == null) {
                return null;
            }

            var index = 1;
            response.forEach(function (item) { //used for collections returned with all their items' upgradeTypeId = 0
                if (item.upgradeTypeId != index) {
                    item.upgradeTypeId = index;
                }
                index++;
            });
            return response;
        }
    });
